import type { Position } from '@talos/kyoko';

/** Row type shared by Positions V3 desktop and mobile blotters (`UnifiedPosition` extends `Position`). */
export type PositionsBlotterRow = Position;

export function getPositionsBlotterRowKey(row: PositionsBlotterRow): string {
  return row.rowID;
}

export function getPositionsBlotterRowAsset(row: PositionsBlotterRow): string {
  return row.Asset;
}

export function getPositionsBlotterLastUpdateTime(row: PositionsBlotterRow): string | undefined {
  return row.LastUpdateTime;
}
